<script>
import StatsDataService from "@/services/StatsDataService";

export default {
  name: "ChartUsersCountries",
  data() {
    return {
      series:[],
      chartOptions: {
        chart: {
          id: 'users-countries',
          type: 'donut',
        },
        labels: [],
        dataLabels: {
          enabled: true
        },

        legend: {
          position: 'bottom'
        },
        noData: {
          text: 'Loading...'
        }
      },
      filtersDates: {
        selected: '1M',
        options: [
          {value:'T', text:'T.'},
          {value:'Y', text:'Y.'},
          {value:'1W', text:'1W'},
          {value:'1M', text:'1M'},
          {value:'3M', text:'3M'},
          {value:'6M', text:'6M'},
          {value:'1Y', text:'1Y'},
          {value:'ALL', text:'ALL'},
        ]
      }
    }
  },
  methods: {
    handleDateChange() {
      this.loadData();
    },

    loadData() {
      const params = {date: this.filtersDates.selected};
      StatsDataService.getUsersCountryStats(params)
          .then(response => {
            this.series = response.data.series;
            this.chartOptions = {...this.chartOptions, ...{
                labels: response.data.labels
            }};
          })
          .catch(error => {
            window.console.error("StatsDataService.getUsersCountryStats failed...", error);
          });
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<template>
  <div class="card-body" id="cardChartCountries">
    <h5 class="card-title">Countries Distribution</h5>
    <b-form-radio-group
        v-model="filtersDates.selected"
        :options="filtersDates.options"
        button-variant="outline-secondary"
        size="sm"
        buttons
        class="mt-1 mb-2"
        @change="handleDateChange"
    ></b-form-radio-group>
    <apexchart
        ref="usersCountriesChart"
        type="donut"
        height="350"
        dir="ltr"
        :series="series"
        :options="chartOptions"
    ></apexchart>
  </div>
</template>

<style>
#cardChartCountries .btn input[type=radio] {
  position: absolute;
  clip: rect(0,0,0,0);
  pointer-events: none;
}

#cardChartCountries .btn {
  margin-top: -8px;
  margin-bottom: 0 !important;
}
</style>